import { render } from "./GroupsListing.vue?vue&type=template&id=65bbceed&ts=true"
import script from "./GroupsListing.vue?vue&type=script&lang=ts"
export * from "./GroupsListing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__